// Client-side navigation. Screens call go(); app.ts decides what each path shows.
import { app, cancelPendingRender, closeSheet, target } from './dom.ts';

type Cleanup = () => void;
let render: (path: string) => void = () => {};
let cleanup: Cleanup | null = null;

/** Register the function that draws a path. Called once by app.ts. */
export function setRenderer(fn: (path: string) => void): void { render = fn; }

/** Something to undo when the person leaves this screen (stop polling, for example). */
export function onLeave(fn: Cleanup): void { cleanup = fn; }

export function go(path: string, replace = false): void {
  history[replace ? 'replaceState' : 'pushState']({}, '', path);
  route();
}

export function route(): void {
  cleanup?.();
  cleanup = null;
  cancelPendingRender();
  closeSheet();
  app.onclick = app.oninput = app.onchange = app.onsubmit = null;
  window.scrollTo(0, 0);
  render(location.pathname);
}

window.addEventListener('popstate', route);
document.addEventListener('click', (e) => {
  const a = target<HTMLAnchorElement>(e, 'a[data-go]');
  if (a && !e.metaKey && !e.ctrlKey) {
    e.preventDefault();
    go(a.getAttribute('href') || '/');
  }
});
